import "../i18n.mjs";
import { useCallback as e } from "react";
import { useTranslation as t } from "react-i18next";
//#region src/enums/useTrEnumNamespace.ts
var n = (n) => {
	let { t: r } = t("enums");
	return e((e) => r(`${n}.${e}`, { defaultValue: e }), [r, n]);
};
//#endregion
export { n as useTrEnumNamespace };
